<template>
  <div id="data-list-list-view" class="data-list-container">
    <vx-card ref="listCard" :title="$t('CashFlow.YearlyFxRateTemplate.Title')" title-color="black" refresh-content-action @refresh="refreshList"> 
      <vs-table
            ref="table"
            v-model="selected"
            pagination
            :max-items="itemsPerPage"
            search
            :data="yearlyFxRateTemplates"            
          >
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
          <vs-row vs-type="flex" vs-justify="space-between">
            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="4">
              <vs-button
                color="primary"
                type="border"
                icon-pack="feather"
                icon="icon-add"
                @click="addNewData"
              >{{$t('AddNew')}}</vs-button>
            </vs-col>
            <vs-col class="mr-5" vs-type="flex" vs-justify="right" vs-align="center" vs-w="4">
              <Pager
                :currentPage="currentPage"
                :itemsPerPage="itemsPerPage"
                :totalCount="yearlyFxRateTemplates.length"
                :queriedItems="queriedItems"
                :pageSizes="[10,20,50]"
                @pageChanged="onPageChanged"
              ></Pager>
            </vs-col>
          </vs-row>
        </div>
        <template slot="thead">
          <vs-th>{{$t('Action')}}</vs-th>
          <vs-th sort-key="code">{{$t('CashFlow.YearlyFxRateTemplate.Name')}}</vs-th>
        </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td width="100px" class="whitespace-no-wrap">
                <feather-icon
                  icon="EditIcon"
                  svgClasses="w-5 h-5 hover:text-primary stroke-current"
                  @click.stop="editData(tr)"
                  v-b-tooltip.hover :title="$t('Edit')"
                />
                <feather-icon
                  icon="CopyIcon"
                  svgClasses="w-5 h-5 hover:text-primary stroke-current"
                  class="ml-2"
                  @click.stop="duplicateData(tr)"
                  v-b-tooltip.hover :title="$t('Duplicate')"
                />
                <feather-icon
                  icon="TrashIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-2"
                  @click.stop="openDeleteConfirm(tr.id)"
                  v-b-tooltip.hover :title="$t('Delete')"
                />       
              </vs-td>
              <vs-td>
                <p class="font-medium truncate">{{ tr.name }}</p>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </vx-card>
  </div>
</template>
<script>
import module from "@/store/cashflow/moduleCashFlow.js";
import { Pager } from "@/app/shared/components";

export default {
  /* eslint-disable vue/no-unused-components */
  components: {
    Pager
  },
  data() {
    return {
      selected: [],    
      itemsPerPage: 20,
      isMounted: false, 
      yearlyFxRateTemplates: []
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    queriedItems() {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.yearlyFxRateTemplates.length;
    }
  },
  methods: {
    refreshList() {
      this.$cqrsGet("cashflow/lom/yearlyFxRateTemplates/findAll/")
        .then((response) => {
          this.yearlyFxRateTemplates = response.data.model;
        })
        .finally(() => {
          this.$refs.listCard.removeRefreshAnimation()
        });
    },
    onPageChanged(val) {
      this.itemsPerPage = val;
    },
    openDeleteConfirm(id) {
      this.$deleteConfirmation({
        text: this.$t('CashFlow.YearlyFxRateTemplate.ConfirmDelete'),
        accept:  () => this.deleteData(id)
      });
    },
    deleteData(id) {
      this.$vs.loading();
      this.$cqrsPost('cashflow/lom/yearlyFxRateTemplates/delete', { id })
        .then(() => {
          this.$notifyDeleteSuccess(this.$t("CashFlow.YearlyFxRateTemplate.DeletedConfirmation"));
        })
        .finally(() => {
          this.$vs.loading.close();
          this.$refs.listCard.refreshcard();
        });
    },
    addNewData() {
      this.$router.push({ name: 'BSG-CashFlow-Templates-YearlyFxRateTemplates-Edit', params: { editData: null} });
    },
    editData(model) {
      this.$router.push({ name: 'BSG-CashFlow-Templates-YearlyFxRateTemplates-Edit', params: { editData: model } });
    },
    duplicateData(model) {
      const id = model.id;
      this.$cqrsPost('cashflow/lom/yearlyFxRateTemplates/duplicate', { id })
        .then(() => {                
          this.$notifySaveSuccess();
          this.refreshList();
        })
    }
  },
  created() {
    if (!module.isRegistered) {
      this.$store.registerModule("cashflow", module);
      module.isRegistered = true;
    }
  },
  mounted() {
    if (!this.isMounted) {
      this.$refs.listCard.refreshcard();
    }
    this.isMounted = true;
  }
};
</script>